<template>
  <main
    class="text-[var(--foreground)] dark:bg-[linear-gradient(109.63deg,var(--color-1)_3.67%,var(--color-2)_83.91%)] bg-[#eaeaea]"
    v-show="hydrated"
  >
    <WrOfficialPartnerHeader />
    <WrHeader />
    <WrBreadCrumb
      :appendclass="true"
      class="text-white absolute w-full left-1/2 -translate-x-1/2 top-32 z-40"
    />

    <div class="pt-10">
      <slot />
    </div>

    <section
      class="grid place-items-center z-10 relative pt-16 lg:pt-32 max-md:px-4 overflow-hidden"
      id="mask-section"
    >
      <LazyWrAnimatedImg />
    </section>
    <WrFooter />
  </main>
</template>
<script setup lang="ts">
import { ref, onMounted } from "vue";
const hydrated = ref(false);
onMounted(() => {
  hydrated.value = true;
});
</script>
